import clsx from 'clsx';

interface AnswerBoxProps {
  variant: 'large' | 'medium';
  children: React.ReactNode;
}

export const AnswerBox = ({ variant, children }: AnswerBoxProps) => {
  return (
    <div
      className={clsx(
        'relative w-fit rounded border border-gray-200 px-6 text-zinc-700',
        variant === 'large' && 'min-w-52 py-4',
        variant === 'medium' && 'min-w-36 py-3',
      )}
    >
      <p
        className={clsx(
          'absolute left-2 top-0 -translate-y-1/2 bg-white px-1 uppercase text-zinc-600',
          variant === 'large' && 'text-xs',
          variant === 'medium' && 'text-[10px]',
        )}
      >
        Your answer
      </p>

      <div
        className={clsx(
          'font-medium',
          variant === 'large' && 'text-2xl leading-10 tracking-tight',
        )}
      >
        {children}
      </div>
    </div>
  );
};
